@for (violation of violations; track violation) {
<div class="m-t-5">
  <div class="flex-row-container gap-5">
    <fa-icon [icon]="bellIcon"></fa-icon>
    <div>{{ violation.name | translate }} : {{ violation.value }} {{ violation.unit }}</div>
  </div>
</div>
}
